import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
};

export default TrustSignals;
